function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "MyWorksNavigationClick",
  transform: "translate(-408 -24)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_981",
  "data-name": "Group 981",
  transform: "translate(2809 -9470)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_117",
  className: "background",
  "data-name": "Ellipse 117",
  cx: 22,
  cy: 22,
  r: 22,
  transform: "translate(-2401 9494)",
  fill: "#f2f7fa"
})), /*#__PURE__*/React.createElement("g", {
  id: "MojePr\\xE1ceButton_M",
  transform: "translate(412 27)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_365",
  className: "person",
  "data-name": "Group 365",
  transform: "translate(-1388.742 -460.142)",
  fill: "none",
  stroke: "#002d56"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_57",
  "data-name": "Ellipse 57",
  cx: 5.138,
  cy: 5.138,
  r: 5.138,
  transform: "translate(1401.312 466.141)",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_153-2",
  "data-name": "Rectangle 153",
  d: "M1406.45 489.773h-7.708v-4.593a7.685 7.685 0 017.685-7.685h0a7.659 7.659 0 015.434 2.251",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Line_99",
  "data-name": "Line 99",
  strokeWidth: 1,
  d: "M1408.625 482.744h11.261"
}), /*#__PURE__*/React.createElement("path", {
  id: "Line_100",
  "data-name": "Line 100",
  strokeWidth: 1,
  d: "M1408.625 485.941h8.173"
}), /*#__PURE__*/React.createElement("path", {
  id: "Line_101",
  "data-name": "Line 101",
  strokeWidth: 1,
  d: "M1408.625 488.883h11.261"
}), /*#__PURE__*/React.createElement("path", {
  id: "Line_102",
  "data-name": "Line 102",
  strokeWidth: 1,
  d: "M1408.625 492.08h8.173"
}))));

function SvgMyWorkPersonRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyWorkPersonRound);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NCIgaGVpZ2h0PSI0NCIgdmlld0JveD0iMCAwIDQ0IDQ0Ij4KICA8ZyBpZD0iTXlXb3Jrc05hdmlnYXRpb25DbGljayIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQwOCAtMjQpIj4KICAgIDxnIGlkPSJHcm91cF85ODEiIGRhdGEtbmFtZT0iR3JvdXAgOTgxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyODA5IC05NDcwKSI+CiAgICAgIDxjaXJjbGUgaWQ9IkVsbGlwc2VfMTE3IiBjbGFzcz0iYmFja2dyb3VuZCIgZGF0YS1uYW1lPSJFbGxpcHNlIDExNyIgY3g9IjIyIiBjeT0iMjIiIHI9IjIyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjQwMSA5NDk0KSIgZmlsbD0iI2YyZjdmYSIvPgogICAgPC9nPgogICAgPGcgaWQ9Ik1vamVQcsOhY2VCdXR0b25fTSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDEyIDI3KSI+CiAgICAgIDxnIGlkPSJHcm91cF8zNjUiIGNsYXNzPSJwZXJzb24iIGRhdGEtbmFtZT0iR3JvdXAgMzY1IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTM4OC43NDIgLTQ2MC4xNDIpIj4KICAgICAgICA8Y2lyY2xlIGlkPSJFbGxpcHNlXzU3IiBkYXRhLW5hbWU9IkVsbGlwc2UgNTciIGN4PSI1LjEzOCIgY3k9IjUuMTM4IiByPSI1LjEzOCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTQwMS4zMTIgNDY2LjE0MSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMmQ1NiIgc3Ryb2tlLXdpZHRoPSIyIi8+CiAgICAgICAgPHBhdGggaWQ9IlJlY3RhbmdsZV8xNTMiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDE1MyIgZD0iTTE0MTQuMTEyLDQ4NS4xOCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAyZDU2IiBzdHJva2Utd2lkdGg9IjEiLz4KICAgICAgICA8cGF0aCBpZD0iUmVjdGFuZ2xlXzE1My0yIiBkYXRhLW5hbWU9IlJlY3RhbmdsZSAxNTMiIGQ9Ik0xNDA2LjQ1LDQ4OS43NzNoLTcuNzA4VjQ4NS4xOGE3LjY4NSw3LjY4NSwwLDAsMSw3LjY4NS03LjY4NWgwYTcuNjU5LDcuNjU5LDAsMCwxLDUuNDM0LDIuMjUxIiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDJkNTYiIHN0cm9rZS13aWR0aD0iMiIvPgogICAgICAgIDxsaW5lIGlkPSJMaW5lXzk5IiBkYXRhLW5hbWU9IkxpbmUgOTkiIHgyPSIxMS4yNjEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE0MDguNjI1IDQ4Mi43NDQpIiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDJkNTYiIHN0cm9rZS13aWR0aD0iMSIvPgogICAgICAgIDxsaW5lIGlkPSJMaW5lXzEwMCIgZGF0YS1uYW1lPSJMaW5lIDEwMCIgeDI9IjguMTczIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNDA4LjYyNSA0ODUuOTQxKSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAyZDU2IiBzdHJva2Utd2lkdGg9IjEiLz4KICAgICAgICA8bGluZSBpZD0iTGluZV8xMDEiIGRhdGEtbmFtZT0iTGluZSAxMDEiIHgyPSIxMS4yNjEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE0MDguNjI1IDQ4OC44ODMpIiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDJkNTYiIHN0cm9rZS13aWR0aD0iMSIvPgogICAgICAgIDxsaW5lIGlkPSJMaW5lXzEwMiIgZGF0YS1uYW1lPSJMaW5lIDEwMiIgeDI9IjguMTczIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNDA4LjYyNSA0OTIuMDgpIiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDJkNTYiIHN0cm9rZS13aWR0aD0iMSIvPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };